/** URL `?tab=` values for purchase order overview. */
export const PurchaseOrderOverviewTabParam = {
  OVERVIEW: "overview",
  ITEMS: "items",
} as const;

export function poOverviewActiveTabId(tab: string | null): string {
  if (tab === PurchaseOrderOverviewTabParam.ITEMS) return "2";
  return "1";
}

export function searchParamForPoOverviewTabId(tabId: string): string | null {
  if (tabId === "2") return PurchaseOrderOverviewTabParam.ITEMS;
  return null;
}

export function isValidPoOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return (
    tab === PurchaseOrderOverviewTabParam.OVERVIEW ||
    tab === PurchaseOrderOverviewTabParam.ITEMS
  );
}
